import { resolveImage as p } from "../../../helpers/index.js";
const c = (o) => {
  const n = [];
  return o?.forEach((i) => {
    i?.items.forEach((s) => {
      const { choosenEmployee: r, secondaryJobtitle: a, dontShowContactInfo: t, description: m } = s.content.properties || {}, e = r?.[0]?.properties || {};
      n.push({
        name: r?.[0]?.name || "",
        title: a || e.position || "",
        mail: t ? "" : e.mail || "",
        phone: t ? "" : e.phone || "",
        secondaryPhone: t ? "" : e.secondaryPhone || "",
        image: e.image?.[0] ? p(e.image) : void 0,
        description: m || ""
      });
    });
  }), n;
}, h = (o) => ({
  title: o.properties?.header || "",
  items: c(o.areas)
});
export {
  h as employeeCardsDeliveryApiParser
};
